











































































































import { Component, Prop } from 'vue-property-decorator';
import { Validation, validationMixin } from 'vuelidate';
import { mixins } from 'vue-class-component';
import { Validations } from 'vuelidate-property-decorators';
import { required, email, requiredIf } from 'vuelidate/lib/validators';

import { UserFormType } from './models/user-form-type';
import { NewUserServiceFactory } from './models/new-user-service-factory';
import { PhoneNumberDetails } from '@/models/phone-number-details';
import UserPhoneInput from '@/components/form pickers/UserPhoneInput.vue';
import UserAutocomplete from './UserAutocomplete.vue';
import UserCountrySelect from '@/components/form pickers/UserCountrySelect.vue';
import FormInputRow from '@/components/form pickers/FormInputRow.vue';
import Toast from '@/components/display/toast.vue';
import { User } from '@/api';
import { UserInput } from './models/user-input';

@Component({
	components: {
		UserPhoneInput,
		UserAutocomplete,
		UserCountrySelect,
		FormInputRow,
	},
})
export default class AddUserForm extends mixins(validationMixin) {
	@Prop({ required: true, type: String })
	private type!: UserFormType;

	@Prop({ required: false, type: Number })
	private orgId?: number;

	@Prop({ required: false, type: String })
	private orgType?: string;

	@Prop({ required: false, type: Number })
	private productId?: number;

	@Validations()
	public validations() {
		return {
			user: {
				firstName: { required },
				email: { required, email },
			},
			service: {
				selectedProductPermission: {
					required: requiredIf(() => this.type === 'productPermission'),
				},
				selectedRole: {
					required: requiredIf(() => this.type === 'orgRole'),
				},
			},
		};
	}

	public get title(): string {
		switch (this.type) {
			case 'productPermission':
				return 'Add User to Product';
			case 'orgRole':
				return 'Add User to Org';
			default: {
				return 'Create New User';
			}
		}
	}

	public phoneValid: boolean = true;

	private toast: Toast = new Toast();
	private service = NewUserServiceFactory.create(this.type, {
		orgId: this.orgId,
		orgType: this.orgType,
		productId: this.productId,
	});

	public get user(): UserInput {
		return this.service.userForm;
	}

	public get validationModel(): Validation {
		return this.$v.user;
	}

	public isValid(field: Validation) {
		return field && field.$dirty ? !field.$invalid : null;
	}

	public async onSubmit(bvModalEvt: Event): Promise<void> {
		bvModalEvt.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid || this.phoneValid === false) {
			return;
		}
		const response = await this.service.save();
		if ('error' in response) {
			this.toast.makeToast(response.error, 'Error', 'danger');
		} else {
			this.$emit('userSuccess');
			this.toast.makeToast('User added', 'Success', 'success');
			this.$bvModal.hide('add-user-modal');
		}
	}

	public onHidden(): void {
		this.service.cancel();
		this.$v.$reset();
	}

	public onUserSuggestionSelected(user: User): void {
		this.service.updateUserValues(user);
		(this.$refs.phoneInput as UserPhoneInput).setPhone(user.phone ?? null);
	}

	public onCountrySelected(countryCode: string): void {
		this.service.updateUserValues({
			...this.user,
			preferences: {
				...(this.user.preferences ?? {}),
				country: countryCode,
			},
		});
	}

	public onFirstNameUpdated(firstName: string): void {
		this.service.updateUserValues({
			...this.user,
			firstName: firstName ?? '',
		});
	}

	public onLastNameUpdated(lastName: string): void {
		this.service.updateUserValues({
			...this.user,
			lastName: lastName === '' ? null : lastName,
		});
	}

	public onEmailUpdated(email: string): void {
		this.service.updateUserValues({
			...this.user,
			email,
		});
	}

	public onPhoneChanged(params: { phone: string; phoneObject: PhoneNumberDetails }): void {
		if (params.phoneObject.valid === true) {
			this.phoneValid = true;
			const { countryCallingCode, nationalNumber } = params.phoneObject;
			this.service.updateUserValues({
				...this.user,
				phone: `+${countryCallingCode} ${nationalNumber}`,
			});
			return;
		} else if (params.phone === '') {
			this.phoneValid = true;
		} else {
			this.phoneValid = false;
		}
		this.service.updateUserValues({
			...this.user,
			phone: null,
		});
	}
}
